import { useMsal } from '@azure/msal-react';
import { RedirectRequest } from '@azure/msal-browser';
import { b2cPolicies, loginRequest } from '../config/AuthConfig.base';
import { useSaveLocation } from './UseSaveLocation.hook';

/**
 * Hook for initiating local account sign-up flow with MSAL
 * Uses PKCE automatically via MSAL's authorization code flow
 */
export function useLocalSignUp() {
  const { instance } = useMsal();
  const [, saveLocation] = useSaveLocation();

  /**
   * Initiates the local sign-up flow with B2C
   * MSAL automatically handles PKCE when response_type is 'code'
   */
  const startLocalSignUp = () => {
    // Save the current location for redirect after auth
    saveLocation({ pathname: '/', search: '', hash: '', state: null, key: '' });

    // Build the redirect request with local sign-up authority
    const request: RedirectRequest = {
      authority: b2cPolicies.authorities.localSignUp.authority,
      scopes: loginRequest.scopes,
      redirectUri: window.location.origin + '/signup-redirect',
      prompt: 'login', // Ensures sign-up flow is shown
      // MSAL will automatically add PKCE parameters (code_challenge, code_challenge_method)
      // when using authorization code flow (default with loginRedirect)
    };

    // Initiate the redirect - MSAL handles PKCE generation internally
    instance.loginRedirect(request);
  };

  return {
    startLocalSignUp,
  };
}
